// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $Model,
  $ModelUpsertParams,
} from 'common.data';

// Global Enums
import {
  GroupType,
} from 'common.data';

// Global Components
import * as React from 'react';
import {
  Col,
  Row,
} from 'reactstrap';
import {
  AvField,
} from 'availity-reactstrap-validation';
import {
  InputFile,
  InputNumber,
} from '@vroskus/library-components';

// Helpers
import _ from 'lodash';
import ErrorLog from '@vroskus/library-sentry/dist/browser';
import {
  groupTypeLabel,
} from 'common.language';
import config from '../../../config';

// Types
type $Props = $Translate & {
  item: $Model<'Group'> | $ModelUpsertParams<'Group'>;
};

const GroupFieldsView = function ({
  item,
  t,
}: $Props) {
  return (
    <>
      <Row>
        <Col>
          <AvField
            label={t('Title')}
            name={'Name'}
            required
            value={item.Name}
          />
        </Col>
        <Col>
          <AvField
            label={t('Type')}
            name={'Type'}
            required
            type={'select'}
            value={item.Type}
          >
            {_.map(
              GroupType,
              (i) => (
                <option
                  key={i}
                  value={i}
                >
                  {t(groupTypeLabel[i])}
                </option>
              ),
            )}
          </AvField>
        </Col>
      </Row>
      <Row>
        <Col>
          <InputFile
            fileDirUrl={`${config.CDN_URL}/images/max`}
            imageThumbDirUrl={`${config.CDN_URL}/images/min`}
            label={t('Image')}
            labelChangeFile={t('Change file')}
            labelError={t('Error')}
            labelFile={t('File')}
            name={'Image'}
            onError={ErrorLog.exception}
            required
            uploadUrl={`${config.CDN_URL}/v1.0/upload/image`}
            value={item.Image}
          />
        </Col>
        <Col>
          <InputNumber
            label={t('Crew quantity')}
            name={'CrewQuantity'}
            value={item.CrewQuantity}
          />
        </Col>
      </Row>
    </>
  );
};

export default GroupFieldsView;
